/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from "react";
import { Button, ButtonProps } from "@mui/material";
import { useDeviceType } from "@hook/useDeviceType";
import { EIdFormat, formatId } from "@utils/idFormat";

interface IParams {
    labelText: string;
    disableFullWidth?: boolean;
}

export const LabeledButton = forwardRef<HTMLButtonElement, IParams & Omit<ButtonProps, "aria-label" | "fullWidth">>(
    (props, ref) => {
        const { labelText, disableFullWidth, id: providedId, children, ...buttonProps } = props;

        const { isMobile } = useDeviceType();

        const id = providedId ?? formatId(labelText, EIdFormat.BUTTON);

        return (
            <Button {...buttonProps} aria-label={labelText} fullWidth={!disableFullWidth && isMobile} id={id} ref={ref}>
                {children}
            </Button>
        );
    }
);

LabeledButton.displayName = "LabeledButton";
